export const UXB_ROUTE_NAMES = {
  cart: '/cart',
  userProfile: '/user/profile',
  webinar: '/webinar'
};
